
import TranResourcesApi from './src/Tranresources'
import RegionList from './src/RegionList'
import LedgetApi from './src/LedGet'
import SendLogApi  from './src/SendLog'


let apis = {
   TranResourcesApi,
   RegionList,
   LedgetApi,
   SendLogApi
};

export default apis;
